import { connect } from "react-redux";
import get from "lodash/get";

import {
  getDashboards as onGetDashboards,
  getDashboardCodes as onGetDashboardCodes,
} from "../../actions/dashboardsActions";

const mapStateToProps = (state) => ({
  dashboardsDataState: state.dashboards.dataState,
  dashboardsData: get(state, ["dashboards", "data", "items"], []),
  dashboardsCodesDataState: state.dashboardsCodes.dataState,
  dashboardsCodesData: get(state, ["dashboardsCodes", "data", "codes"], {}),
  dashboardsErrors: get(state, ["dashboards", "errors"], []),
});

const mapDispatchToProps = {
  onGetDashboards,
  onGetDashboardCodes,
};

const withDashboards = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withDashboards };
